import {AppState} from '../../configStore';

export const selectIsAgeConfirmed = (state: AppState) => state.ageRestriction;
